export default {
	title: 'Centrála',
	subheader: 'Regiony v kampani',
	region: 'Region',
	channel: 'Distribuční kanál',
	manager: 'Regionální ředitel',
	progress: 'Rozpracováno',
	notDone: 'K vyřízení',
	addMatFulfillment: 'Vyřízenost',
	replication: 'Aktuální náhrada',
	production: 'Aktuální produkce',
};
